import React from 'react';
import { connect } from 'react-redux';
import { string } from 'prop-types';
import Selectors from '~/common/redux/selectors';

import styles from '../styles.module.css';

const ImageAndInfo = ({ imageUrl, dataTestPrefix, model, vin }) => {
  return (
    <>
      <div className={styles.ImageAndInfo}>
        <div className={styles.VehicleImage} data-test={`${dataTestPrefix}-image`}>
          <img src={imageUrl} alt={model} width="100%" />
        </div>
        <div className={styles.Info}>
          <span className="tds-text--h5" data-test={`${dataTestPrefix}-model`}>
            {model}
          </span>
          <p data-test={`${dataTestPrefix}-vin`}>{vin}</p>
        </div>
      </div>
    </>
  );
};

ImageAndInfo.propTypes = {
  dataTestPrefix: string.isRequired,
  imageUrl: string.isRequired,
  model: string.isRequired,
  vin: string.isRequired,
};
ImageAndInfo.defaultProps = {};

export default connect(
  Selectors,
  null
)(ImageAndInfo);
